import { useSelector } from 'react-redux';
import { IRowProps } from '../../../../../../shared/frontend/components/grid/Row';
import { TPremiumCheckoutSurface } from '../../../../../../shared/frontend/components/subscriptions/premiumXsollaAnalytics';
import { useXsollaCheckoutExperience } from '../../../../../../shared/frontend/components/subscriptions/useXsollaCheckoutExperience';
import { doLogin } from '../../../../../../shared/frontend/libs/login';
import { authStateSelector } from '../../../../../../shared/frontend/scripts/selectors/global';
import { PremiumSubscriptionRail } from './premiumSubscriptionRail';

type TPremiumRailProps = {
  checkoutSurface?: TPremiumCheckoutSurface;
  showCheckoutFooter?: boolean;
  className?: string;
  rowProps?: IRowProps;
};

/**
 * The premium purchase rail for any surface outside the Premium page: it binds auth and
 * eligibility itself so every placement offers the same provider to the same buyer.
 */
export function PremiumRail({
  checkoutSurface = 'subscription_options',
  showCheckoutFooter = false,
  className,
  rowProps
}: TPremiumRailProps) {
  const auth = useSelector(authStateSelector);
  const checkoutConfig = useXsollaCheckoutExperience();

  return (
    <PremiumSubscriptionRail
      checkoutConfig={checkoutConfig}
      checkoutSurface={checkoutSurface}
      isAuthenticated={!!auth?.authenticated}
      onRequireAuthentication={() => doLogin()}
      showCheckoutFooter={showCheckoutFooter}
      className={className}
      rowProps={rowProps}
    />
  );
}
